/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import { SubscriptionCustomersTableV2CustomerFragmentDoc } from '../../../../../components/organization/SubscriptionCustomersTableV2/__generated__/SubscriptionCustomersTable.graphql';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type SubscriptionEditPageV2_SubscriptionFragment = { __typename: 'WaveSubscription', id: string, name: string, userGivenName?: string | null, validUntil: any, productId: string, assignable: boolean, status: Types.WaveSubscriptionStatus, usage: { __typename: 'SubscriptionUsage', current: number, max?: number | null }, customers: Array<{ __typename: 'PartialCustomer', id: string }> };

export type WaveSubscriptionEditPageV2OrganizationQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type WaveSubscriptionEditPageV2OrganizationQuery = { __typename: 'Query', organization: { __typename: 'Organization', customers: Array<{ __typename: 'Customer', id: string, name: string, displayCount: number, waveSubscriptionUsage?: number | null, waveSubscriptions?: Array<{ __typename: 'WaveSubscription', id: string, validUntil: any, status: Types.WaveSubscriptionStatus }> | null }>, waveSubscriptions?: Array<{ __typename: 'WaveSubscription', id: string, name: string, userGivenName?: string | null, validUntil: any, productId: string, assignable: boolean, status: Types.WaveSubscriptionStatus, usage: { __typename: 'SubscriptionUsage', current: number, max?: number | null }, customers: Array<{ __typename: 'PartialCustomer', id: string }> }> | null } };

export type EditSubscriptionV2MutationVariables = Types.Exact<{
  input: Types.SubscriptionUpdateInput;
}>;


export type EditSubscriptionV2Mutation = { __typename: 'Mutation', updateSubscription: { __typename: 'WaveSubscription', id: string, name: string, userGivenName?: string | null, validUntil: any, productId: string, assignable: boolean, status: Types.WaveSubscriptionStatus, usage: { __typename: 'SubscriptionUsage', current: number, max?: number | null }, customers: Array<{ __typename: 'PartialCustomer', id: string }> } };

export type UpdateSubscriptionNameV2MutationVariables = Types.Exact<{
  input: Types.SubscriptionNameUpdateInput;
}>;


export type UpdateSubscriptionNameV2Mutation = { __typename: 'Mutation', updateSubscriptionName: { __typename: 'WaveSubscription', id: string, name: string, userGivenName?: string | null } };

export const SubscriptionEditPageV2_SubscriptionFragmentDoc = gql`
    fragment SubscriptionEditPageV2_subscription on WaveSubscription {
  id
  name
  userGivenName
  usage {
    current
    max
  }
  validUntil
  productId
  assignable
  customers {
    id
  }
  status
}
    `;
export const WaveSubscriptionEditPageV2OrganizationDocument = gql`
    query WaveSubscriptionEditPageV2Organization {
  organization {
    customers {
      ...SubscriptionCustomersTableV2Customer
    }
    waveSubscriptions {
      ...SubscriptionEditPageV2_subscription
    }
  }
}
    ${SubscriptionCustomersTableV2CustomerFragmentDoc}
${SubscriptionEditPageV2_SubscriptionFragmentDoc}`;

/**
 * __useWaveSubscriptionEditPageV2OrganizationQuery__
 *
 * To run a query within a React component, call `useWaveSubscriptionEditPageV2OrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useWaveSubscriptionEditPageV2OrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWaveSubscriptionEditPageV2OrganizationQuery({
 *   variables: {
 *   },
 * });
 */
export function useWaveSubscriptionEditPageV2OrganizationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<WaveSubscriptionEditPageV2OrganizationQuery, WaveSubscriptionEditPageV2OrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<WaveSubscriptionEditPageV2OrganizationQuery, WaveSubscriptionEditPageV2OrganizationQueryVariables>(WaveSubscriptionEditPageV2OrganizationDocument, options);
      }
export function useWaveSubscriptionEditPageV2OrganizationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WaveSubscriptionEditPageV2OrganizationQuery, WaveSubscriptionEditPageV2OrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<WaveSubscriptionEditPageV2OrganizationQuery, WaveSubscriptionEditPageV2OrganizationQueryVariables>(WaveSubscriptionEditPageV2OrganizationDocument, options);
        }
export type WaveSubscriptionEditPageV2OrganizationQueryHookResult = ReturnType<typeof useWaveSubscriptionEditPageV2OrganizationQuery>;
export type WaveSubscriptionEditPageV2OrganizationLazyQueryHookResult = ReturnType<typeof useWaveSubscriptionEditPageV2OrganizationLazyQuery>;
export type WaveSubscriptionEditPageV2OrganizationQueryResult = ApolloReactCommon.QueryResult<WaveSubscriptionEditPageV2OrganizationQuery, WaveSubscriptionEditPageV2OrganizationQueryVariables>;
export const EditSubscriptionV2Document = gql`
    mutation EditSubscriptionV2($input: SubscriptionUpdateInput!) {
  updateSubscription(input: $input) {
    id
    ...SubscriptionEditPageV2_subscription
  }
}
    ${SubscriptionEditPageV2_SubscriptionFragmentDoc}`;
export type EditSubscriptionV2MutationFn = ApolloReactCommon.MutationFunction<EditSubscriptionV2Mutation, EditSubscriptionV2MutationVariables>;

/**
 * __useEditSubscriptionV2Mutation__
 *
 * To run a mutation, you first call `useEditSubscriptionV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditSubscriptionV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editSubscriptionV2Mutation, { data, loading, error }] = useEditSubscriptionV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditSubscriptionV2Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EditSubscriptionV2Mutation, EditSubscriptionV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EditSubscriptionV2Mutation, EditSubscriptionV2MutationVariables>(EditSubscriptionV2Document, options);
      }
export type EditSubscriptionV2MutationHookResult = ReturnType<typeof useEditSubscriptionV2Mutation>;
export type EditSubscriptionV2MutationResult = ApolloReactCommon.MutationResult<EditSubscriptionV2Mutation>;
export type EditSubscriptionV2MutationOptions = ApolloReactCommon.BaseMutationOptions<EditSubscriptionV2Mutation, EditSubscriptionV2MutationVariables>;
export const UpdateSubscriptionNameV2Document = gql`
    mutation UpdateSubscriptionNameV2($input: SubscriptionNameUpdateInput!) {
  updateSubscriptionName(input: $input) {
    id
    name
    userGivenName
  }
}
    `;
export type UpdateSubscriptionNameV2MutationFn = ApolloReactCommon.MutationFunction<UpdateSubscriptionNameV2Mutation, UpdateSubscriptionNameV2MutationVariables>;

/**
 * __useUpdateSubscriptionNameV2Mutation__
 *
 * To run a mutation, you first call `useUpdateSubscriptionNameV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubscriptionNameV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSubscriptionNameV2Mutation, { data, loading, error }] = useUpdateSubscriptionNameV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSubscriptionNameV2Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateSubscriptionNameV2Mutation, UpdateSubscriptionNameV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateSubscriptionNameV2Mutation, UpdateSubscriptionNameV2MutationVariables>(UpdateSubscriptionNameV2Document, options);
      }
export type UpdateSubscriptionNameV2MutationHookResult = ReturnType<typeof useUpdateSubscriptionNameV2Mutation>;
export type UpdateSubscriptionNameV2MutationResult = ApolloReactCommon.MutationResult<UpdateSubscriptionNameV2Mutation>;
export type UpdateSubscriptionNameV2MutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateSubscriptionNameV2Mutation, UpdateSubscriptionNameV2MutationVariables>;